import React, { useState } from "react";
// import Logos from "./logos/splashScreen/splashScreen";
import Logos from "./logos/logos";
import WelcomeScreens from "./welcome/welcome";
import Banners from "./banners/banners";

const CMS = () => {
  const [activeTab, setActiveTab] = useState("Logos");

  return (
    <div className="px-md-2 px-1 py-md-2 py-1">
      {/* <h2 className="">Content Management System</h2> */}
      <ul className="nav nav-tabs">
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className={`nav-link ${activeTab === "Logos" ? "active" : ""}`}
            onClick={() => setActiveTab("Logos")}
            style={{
              color: activeTab !== "Logos" ? "#2c3e50" : "",
              fontWeight: activeTab == "Logos" ? "600" : "normal",
              fontSize: activeTab == "Logos" ? "large" : "medium",
            }}
          >
            Logos
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className={`nav-link ${activeTab === "Banners" ? "active" : ""}`}
            onClick={() => setActiveTab("Banners")}
            style={{
              color: activeTab !== "Banners" ? "#2c3e50" : "",
              fontWeight: activeTab == "Banners" ? "600" : "normal",
              fontSize: activeTab == "Banners" ? "large" : "medium",
            }}
          >
            Banners
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className={`nav-link ${
              activeTab === "Welcome Screens" ? "active" : ""
            }`}
            onClick={() => setActiveTab("Welcome Screens")}
            style={{
              color: activeTab !== "Welcome Screens" ? "#2c3e50" : "",
              fontWeight: activeTab == "Welcome Screens" ? "600" : "normal",
              fontSize: activeTab == "Welcome Screens" ? "large" : "medium",
            }}
          >
            Welcome Screens
          </a>
        </li>
      </ul>
      {activeTab === "Logos" && <Logos />}
      {activeTab === "Banners" && <Banners />}
      {activeTab === "Welcome Screens" && <WelcomeScreens />}
    </div>
  );
};

export default CMS;
